import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.css']
})
export class ModalConfirmComponent implements OnInit {
  @Input() header:string=null;
  @Input() text:string=null;
  @Input() acceptText:string=null;
  @Input() cancelText:string=null;
  @Input() viewHeader:number=0;
  
  ////////////////
  constructor(
    private modalService: NgbModal
  ) { }
  ngOnInit() {
  }
  
  //
  accept=()=> {
    this.modalService.dismissAll("accept");
  }

  cancel=()=> {
    this.modalService.dismissAll("cancel");
  }
}